import React from 'react'
import WebcamModal from './WebcamModal.jsx'

export default function ChatWidget({ onSend, onClose }) {
  return (
    <div className="chat">
      <WebcamModal
          open={true}
          onClose={onClose}
          onCapture={onSend}
      />
    </div>
  )
}
